import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

function WelcomeCard({ userName, lastUpdate }) {
  return (
    <Paper sx={{ p: 3, background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', color: 'white' }}>
      <Typography variant="h5" gutterBottom>
        Welcome back, {userName}!
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.85 }}>
        {lastUpdate
          ? `Last updated: ${new Date(lastUpdate).toLocaleString()}`
          : 'Your dashboard is up to date.'}
      </Typography>
    </Paper>
  );
}

export default WelcomeCard;
